export enum LoadTypeEnum {
  fullPallet = 'Standard full pallet',
  halfPallet = 'Standard 1/2 pallet',
  quaterPallet = 'Standard 1/4 pallet',
  euroFullPallet = 'Euro full pallet',
  euroHalfPallet = 'Euro 1/2 pallet',
  euroQuaterPallet = 'Euro 1/4 pallet',
  crates = 'Creates',
  boxes = 'Boxed',
  bags = 'Bags',
}
